interface DeliveryListItem {
  id: number;
  reference: string;
  scheduled_date?: string;
  delivery_address: string;
  state: string;
  status_label: string;
  status_color: 'blue' | 'yellow' | 'green' | 'red';
}

interface DeliveryListResponse {
  total: number;
  page: number;
  page_size: number;
  items: DeliveryListItem[];
}

const API_BASE_URL = 'https://moncopieur.cloud-erp.ma';

const getAuthHeaders = (token: string) => {
  if (!token) {
    throw new Error('No authentication token provided');
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};

export const deliveriesApi = {
  getDeliveries: async (token: string, page: number = 1, pageSize: number = 20): Promise<DeliveryListResponse> => {
    const response = await fetch(`${API_BASE_URL}/api/deliveries?page=${page}&page_size=${pageSize}`, {
      method: 'GET',
      headers: getAuthHeaders(token),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch deliveries');
    }

    return response.json();
  },

  getDelivery: async (token: string, id: number): Promise<DeliveryListItem> => {
    const response = await fetch(`${API_BASE_URL}/api/deliveries/${id}`, {
      method: 'GET',
      headers: getAuthHeaders(token),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch delivery');
    }

    return response.json();
  },

  downloadDeliverySlip: async (token: string, id: number): Promise<Blob> => {
    const response = await fetch(`${API_BASE_URL}/api/deliveries/${id}/pdf`, {
      method: 'GET',
      headers: getAuthHeaders(token),
    });

    if (!response.ok) {
      throw new Error('Failed to download delivery slip');
    }

    return response.blob();
  },
};